import { observer } from 'mobx-react-lite'
import React, { useCallback } from 'react'
import { StatusBar, TouchableOpacity, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useRouter } from 'expo-router'

import { Text } from '../../components'
import { MainHeader } from '../../components/MainHeader/MainHeader'
import { useStore } from '../../models'
import { GameModeTag } from '../../models/api-store'
import { startStyles } from './style'

export const OpenTable = observer(() => {
  const router = useRouter()
  const store = useStore()

  const navToJoin = useCallback(() => {
    if (router.canGoBack()) {
      return router.back()
    }
    router.replace('/play')
  }, [])

  const navToLandingScreen = useCallback(
    (gameMode: GameModeTag) => {
      store.communication.clearChannel()
      store.game.clearCurrentTournament()
      router.navigate(`/game/join/open-tab/${gameMode}`)
    },
    [store.communication, store.game]
  )

  return (
    <SafeAreaView style={startStyles.container}>
      <StatusBar animated barStyle="dark-content" />
      <MainHeader
        leftPress={navToJoin}
        headerContainerStyle={{
          backgroundColor: '#F6F2E9'
        }}
        titleStyle={{ color: '#000000', fontSize: 30, fontFamily: 'FeatureDeckApp-Bold' }}
        title="Open Table"
      />
      <View
        style={{
          flex: 1,
          backgroundColor: '#F6F2E9',
          paddingHorizontal: 35
        }}
      >
        <TouchableOpacity
          style={startStyles.openTableCardContainer}
          onPress={() => navToLandingScreen(GameModeTag.default)}
        >
          <Text
            allowFontScaling={false}
            tx="openTableScreen.quickGame"
            style={[startStyles.title, { color: '#121212' }]}
          />
          <Text
            allowFontScaling={false}
            tx="openTableScreen.quickGameDescription"
            style={[startStyles.discription, { color: '#121212' }]}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[startStyles.openTableCardContainer, { backgroundColor: '#FF7222' }]}
          onPress={() => navToLandingScreen(GameModeTag.tournament)}
        >
          <Text
            allowFontScaling={false}
            tx="openTableScreen.tournamentStyle"
            style={[startStyles.title, { color: '#121212' }]}
          />
          <Text
            allowFontScaling={false}
            tx="openTableScreen.tournamentDescription"
            style={[startStyles.discription, { color: '#121212' }]}
          />
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  )
})
